import { getNewbuildingChatContacts } from '@cian/newbuilding-chat-component';

import { INewbuilding } from '../../types/newbuilding';

export const isBuilderChatEnabledByNewbuilding = ({ builders, sellers }: INewbuilding) => {
  const chatContacts = getNewbuildingChatContacts(builders, sellers);

  return chatContacts.length > 0;
};
